import closeIcon from "../../images/new/meme/close.svg";
import CustomDropdown from "..//MemeGenerator/CustomDropdown";
import LeftAlign from "../../images/new/meme/alignLeft.svg";
import CenterAlign from "../../images/new/meme/alignCenter.svg";
import RightAlign from "../../images/new/meme/alignRight.svg";
export default ({setState,text,generateUniqueKey,changeText,changeEntireText,state,fontFamilies,fontWeights,handleClose})=>{
    return (
      <div
      id="customize"
      className="customizeSection"
      style={{ overflowY: "auto", maxHeight: "600px" }}
    >

      <h3>Customize</h3>
      {Object.keys(text).map((key, index) => (
        <div className="addText">
          <div className="addTextHeader">
            <h4>{`Text ${index + 1}`}</h4>
            <button
              onClick={() => {
                const currentState = state[state.length - 1];
                const temp = { ...currentState.text };
                delete temp[key];
                setState([
                  ...state,
                  {
                    selectedAssets: { ...currentState.selectedAssets },
                    text: { ...temp },
                  },
                ]);
              }}
              className="removeAddText"
            >
              <img src={closeIcon} alt="Close" />
            </button>
          </div>
          <textarea
            name={`Text${index + 1}`}
            id=""
            rows="3"
            placeholder="Top Text"
            value={text[key].text}
            onChange={(e) => {
              changeText(key, "text", e.target.value);
            }}
          ></textarea>
          <div className="customizeActions">
            <div className="customizeDropdowns">
              <CustomDropdown
                options={fontFamilies}
                value={text[key].fontFamily}
                setValue={(val) => {
                  changeText(key, "fontFamily", val);
                }}
                extraClass={"extraDropdownClass"}
              />
            </div>
            <div className="customizeAlignments">
              <button
                onClick={() => {
                  changeText(key, "align", "left");
                }}
              >
                <img src={LeftAlign} alt="Left Align" />
              </button>
              <button
                onClick={() => {
                  changeText(key, "align", "center");
                }}
              >
                <img src={CenterAlign} alt="Center Align" />
              </button>
              <button
                onClick={() => {
                  changeText(key, "align", "right");
                }}
              >
                <img src={RightAlign} alt="Right Align" />
              </button>
            </div>
          </div>
          <div className="colorSelect">
            <span>Select Color:</span>
            <input
              type="color"
              name=""
              id=""
              className="colorInput"
              value={text[key].fill}
              onChange={(e) => {
                changeText(key, "fill", e.target.value);
              }}
            />
          </div>
        </div>
      ))}
      <button
        className="customButton primaryButton w-100"
        onClick={() => {
          const key = generateUniqueKey();
          changeEntireText(key, {
            text: "",
            fontFamily: fontFamilies[0],
            fontWeight: fontWeights[0],
            id: key,
            fill: "#FFFFFF",
            aligm: "left",
            stroke: "black",
          });
        }}
      >
        Add Text
      </button>
    </div>
    )
}